import { LabelService } from '../../../data/services'
import { Label } from '../../../data/models'
import { IDataServiceConfig, ModelRepository } from '../../../model-repository'
import { IEntityMappingConfig } from '../../..'

export const LabelConfig: IDataServiceConfig<Label> = {
  service: LabelService,
  deps: [ModelRepository],
  endpoint: 'exams/labels',
  model: Label,
  presenter: null,
  backend: 'uncached'
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/config/services/data/label.config.ts